import React, {FC, Fragment, ReactNode, useContext} from 'react';
import {ErrorInformerRenderContext} from './ErrorInformerRenderContext';

interface ErrorInformerRendererProps {
	renderMessage(): ReactNode;
}

export const ErrorInformerRenderer: FC<ErrorInformerRendererProps> = props => {
	const {renderMessage, children} = props;

	const shownError = useContext(ErrorInformerRenderContext);

	return (
		<>
			{/* Use key to rerender on new error (to start animation) */}
			{shownError && <Fragment key={shownError.id}>{renderMessage()}</Fragment>}
			{children}
		</>
	);
};

ErrorInformerRenderer.displayName = 'ErrorInformerRenderer';
